import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './auth/signin/signin.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './auth/auth-guard.service';
import { AuthAntiGuard } from './auth/auth-anti-guard.service';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { MultiRiskComponent } from './admin/multi-risk/multi-risk.component';
import { ApplicationComponent } from './application/application/application.component';
import { OffersComponent } from './application/offers/offers.component';
import { InvoiceComponent } from './application/invoice/invoice.component';
import { DocuSentComponent } from './application/docu-sent/docu-sent.component';
import { DocuSignComponent } from './application/docu-sign/docu-sign.component';
import { BankInfoComponent } from './application/bank-info/bank-info.component';
import { ApplicationsListComponent } from './applications-list/applications-list.component';
import { CustomerSupportComponent } from './customer-support/customer-support.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutComponent } from './about/about.component';
import { AuthTokenGuard } from './auth/auth-token-guard.service';
import { OffersTokenComponent } from './application-token/offers-token/offers-token.component';
import { SummaryComponent } from './application/summary/summary.component';
import { UploadLicenseTokenComponent } from './application-token/upload-license-token/upload-license-token.component';
import { PricingComponent } from './admin/pricing-tool/pricing-tool.component';
import { VendorsComponent } from './vendors/vendors.component';
import { ImpersonateComponent } from './admin/impersonate/impersonate.component';
import { AchConverterComponentComponent } from './admin/ach-converter-component/ach-converter-component.component';
import { TermToolComponent } from './admin/term-tool/term-tool.component';
import { MaxOfferToolComponent } from './admin/max-offer-tool/max-offer-tool.component';
import { DataRobotToolComponent } from './admin/data-robot-tool/data-robot-tool.component';
import { GeneralErrorComponent } from './error/general-error/general-error.component';
import { VendorListComponent } from './vendors/vendor-list/vendor-list.component';
import { AuthBrokerGuard } from './auth/auth-broker-guard.service';
import { AddOwnerTokenComponent } from './application-token/add-owner-token/add-owner-token.component';
import { BankInfoTokenComponent } from './application-token/bank-info-token/bank-info-token.component';
import { ContractTokenComponent } from './application-token/contract-token/contract-token.component';
import { DocuSignCompletedComponent } from './application/docu-sign-completed/docu-sign-completed.component';
import { OffersSelectionTokenComponent } from './application-token/offers-selection-token/offers-selection-token.component';
import { OffersSelectionBankInfoTokenComponent } from './application-token/offers-selection-bank-info-token/offers-selection-bank-info-token.component';
import { FinicityLinkComponent } from './application-token/finicity-link/finicity-link.component';
import { ApprovalComponent } from './application/approval/approval.component';
import { DeclinedComponent } from './application/declined/declined.component';
import { DeclineFinicityComponent } from './application/decline-finicity/decline-finicity.component';
import { DeclineDataErrorComponent } from './application/decline-data-error/decline-data-error.component';
import { TokenErrorComponent } from './error/token-error/token-error.component';
import { UploadInvoiceComponent } from './application/invoice/upload-invoice/upload-invoice.component';

const appRoutes: Routes = [
    { path: '', redirectTo: '/signin', pathMatch: 'full' },
    { path: 'support', component: CustomerSupportComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'about', component: AboutComponent },
    { path: 'signin', component: SigninComponent, canActivate: [AuthAntiGuard] },
    { path: 'resetpassword/reset', component: ResetPasswordComponent, canActivate: [AuthAntiGuard] },
    { path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'application', component: ApplicationComponent, canActivate: [AuthGuard] },
    { path: 'approval', component: ApprovalComponent, canActivate: [AuthGuard] },
    { path: 'inlineapp', component: ApplicationComponent, canActivate: [AuthTokenGuard] },
    { path: 'inowner', component: AddOwnerTokenComponent, canActivate: [AuthTokenGuard] },
    { path: 'finicity-link', component: FinicityLinkComponent, canActivate: [AuthTokenGuard] },
    { path: 'upload-license', component: UploadLicenseTokenComponent, canActivate: [AuthTokenGuard] },
    { path: 'inlineappcomp', component: OffersTokenComponent },
    { path: 'application/offers', component: OffersComponent, canActivate: [AuthGuard] },
    { path: 'application/summary', component: SummaryComponent, canActivate: [AuthGuard] },
    { path: 'application/invoice', component: InvoiceComponent, canActivate: [AuthGuard] },
    { path: 'application/bankInfo', component: BankInfoComponent, canActivate: [AuthGuard] },
    { path: 'application/:id/bankinfo', component: BankInfoTokenComponent, canActivate: [AuthTokenGuard] },
    { path: 'application/offerselection', component: OffersSelectionTokenComponent, canActivate: [AuthTokenGuard] },
    { path: 'application/offerselectionbankinfotoken', component: OffersSelectionBankInfoTokenComponent },
    { path: 'application/docuSign', component: DocuSignComponent, canActivate: [AuthGuard] },
    { path: 'application/docuSent', component: DocuSentComponent, canActivate: [AuthGuard] },
    { path: 'application/declined', component: DeclinedComponent },
    { path: 'application/error', component: DeclineFinicityComponent },
    { path: 'application/data-error-declined', component: DeclineDataErrorComponent },
    { path: 'upload-invoice/:id', component: UploadInvoiceComponent, canActivate: [AuthTokenGuard] },
    { path: 'home', component: ApplicationsListComponent, canActivate: [AuthGuard] },
    { path: 'token-error', component: TokenErrorComponent },
    { path: 'general-error', component: GeneralErrorComponent, canActivate: [AuthGuard] },
    { path: 'pricing', component: PricingComponent, canActivate: [AuthGuard] },
    { path: 'term-tool', component: TermToolComponent, canActivate: [AuthGuard] },
    { path: 'max-offer', component: MaxOfferToolComponent, canActivate: [AuthGuard] },
    { path: 'data-robot', component: DataRobotToolComponent, canActivate: [AuthGuard] },
    { path: 'multirisk', component: MultiRiskComponent, canActivate: [AuthGuard] },
    { path: 'impersonate', component: ImpersonateComponent, canActivate: [AuthGuard] },
    { path: 'vendors', component: VendorsComponent, canActivate: [AuthGuard] },
    { path: 'ach-converter', component: AchConverterComponentComponent, canActivate: [AuthGuard] },
    { path: 'vendor', component: VendorListComponent, canActivate: [AuthBrokerGuard] },
    { path: 'contract-token', component: ContractTokenComponent },
    { path: 'completion/trigger', component: DocuSignCompletedComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})

export class AppRoutingModule {

}
